module.exports = "button {\n  margin: 0 1px; }\n\n.red {\n  color: red !important; }\n"